export const NAME = 'report';